export default "__VITE_ASSET__Cp$R_0js__"